import { render } from "./DocumentScroller.vue?vue&type=template&id=6b9a23dd"
import script from "./DocumentScroller.vue?vue&type=script&lang=js"
export * from "./DocumentScroller.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__